import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const PaymentAdd: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={20}>Виды доплаты</Typography>
                    <Typography mb={1} ml={21}>Дата начала</Typography>
                    <Typography mb={1} ml={7}>Дата окончания</Typography>
                    <Typography mb={1} ml={6}>%</Typography>
                    <Typography mb={1} ml={10}>Разряд</Typography>
                    <Typography mb={1} ml={12}>Сумма, руб.</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "400px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "60px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "150px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={12}>Вид доплаты</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "700px", mr: 1 }} 
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={6.7}>Дата назначения с</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>по</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={1.6}>Процент доплат(%%)</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, ml: 2.8, mr: 1}}
                    />
                    <Typography mr={1}>Ставка</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "100px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>по разряду</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "100px", mb: 1, mr: 1}}
                    />
                    <Typography mr={1}>уменьшенному на %</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "100px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={10.9}>Сумма доплат</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mb: 1, mr: 1}}
                    />
                    <Typography>руб</Typography>
                </Box>
            </Body>
        </Box>
    );
};

export default PaymentAdd;

